import { render, staticRenderFns } from "./AiVoiceAgentCallStarter.vue?vue&type=template&id=3c8baa76&scoped=true"
import script from "./AiVoiceAgentCallStarter.vue?vue&type=script&lang=js"
export * from "./AiVoiceAgentCallStarter.vue?vue&type=script&lang=js"
import style0 from "./AiVoiceAgentCallStarter.vue?vue&type=style&index=0&id=3c8baa76&prod&lang=scss&scoped=true"
import style1 from "./AiVoiceAgentCallStarter.vue?vue&type=style&index=1&id=3c8baa76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8baa76",
  null
  
)

export default component.exports